import { LibraryElementTypes } from '../../../enums/libraryElementTypes'
import LibraryElement from '../Sidebar/Library/LibraryElement'

type SimpleElementsLibraryProps = {
  addEntity: (type: LibraryElementTypes) => void
}

const SimpleElementsLibrary = ({ addEntity }: SimpleElementsLibraryProps) => {
  return (
    <div className="flex flex-wrap gap-5">
      <LibraryElement
        type={LibraryElementTypes.LibraryImage}
        onClick={() => addEntity(LibraryElementTypes.LibraryImage)}
      />
      <LibraryElement
        type={LibraryElementTypes.LibraryText}
        onClick={() => addEntity(LibraryElementTypes.LibraryText)}
      />
      <LibraryElement
        type={LibraryElementTypes.LibraryButton}
        onClick={() => addEntity(LibraryElementTypes.LibraryButton)}
      />
      <LibraryElement
        type={LibraryElementTypes.LibraryHorizontalLine}
        onClick={() => addEntity(LibraryElementTypes.LibraryHorizontalLine)}
      />
    </div>
  )
}

export default SimpleElementsLibrary
